import { AutoSuggestInput } from '@popsure/dirty-swan';
import { Option } from '@popsure/dirty-swan/dist/esm/lib/models/autoSuggestInput';
import { useEffect, useState } from 'react';

import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '../../../models';
import { Header } from '../../Screen';

export type AutoSuggestFormProps<Questionnaire extends QuestionnaireQuestions> =
  {
    validate?: (value: string) => boolean;
    options: string[];
  } & QuestionnaireFormProps<Questionnaire, string>;

export const AutoSuggestForm = <Questionnaire extends QuestionnaireQuestions>({
  value: defaultValue,
  options,
  onSubmitValue,
  placeholder,
  featureName,
  question,
  validate,
  setValidForSubmission,
}: AutoSuggestFormProps<Questionnaire>) => {
  const [value, setValue] = useState<string>(defaultValue ?? '');
  const [selectedValues, setSelectedValues] = useState<Array<Option>>([]);
  const [suggestions, setSuggestions] = useState<Array<Option>>([]);

  useEffect(() => {
    const isValid = value && (validate ? validate(value) : true);
    setValidForSubmission(Boolean(isValid));
  });

  const handleSubmit = () => {
    if (!value) {
      throw new Error(
        `[${featureName}] AutoSuggest value is missing for submission for question: ${question}`
      );
    }
    onSubmitValue(value);
  };

  return (
    <Header onSubmit={handleSubmit}>
      <div className="mt16 w100 wmx6">
        <AutoSuggestInput
          placeholder={placeholder ?? ''}
          currentOption={value ?? ''}
          suggestions={suggestions}
          onChange={(value) => {
            setValue(value);
          }}
          handleSuggestionSelected={(value) => {
            setSelectedValues([...selectedValues, value]);
            setValue(value.value);
          }}
          handleSuggestionFetchRequest={({ value }) => {
            const filteredOptions = options
              .map((option) => ({ value: option }))
              .filter((option) =>
                option.value.toLowerCase().includes(value.toLowerCase())
              );
            setSuggestions(filteredOptions);
          }}
          handleSuggestionClearRequest={() => setSuggestions([])}
          wrapText
        />
      </div>
    </Header>
  );
};
